
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['printerSelect', 'paperSelect'];
  static values = {
    accountId: String
  };

  handlePrinterChange() {
    console.log(this.printerSelectTarget.value)
    this.populateStates(this.printerSelectTarget.value);
  }

  populateStates(printerId) {
    const controller = this;

    const selectBox = controller.paperSelectTarget;
    selectBox.innerHTML = '';

    fetch(`/accounts/${controller.data.get('accountId')}/paper_sizes/${printerId}.json`).then((r) => r.json()).then((data) => {
      const inputDiv = controller.stateInputDivTarget;
      data.forEach(item => {
        const opt = document.createElement('option');
        opt.value = item;
        opt.innerHTML = item;

        selectBox.appendChild(opt);
      });
    });
  }
}
